import { IconChevronDown } from './Down';
import { IconChevronDownLarge } from './DownLarge';
import { IconChevronLeft } from './Left';
import { IconChevronRight } from './Right';
import { IconChevronUp } from './Up';
import { IconChevronUpLarge } from './UpLarge';
export const IconChevron = {
    ChevronDown: IconChevronDown,
    ChevronDownLarge: IconChevronDownLarge,
    ChevronLeft: IconChevronLeft,
    ChevronRight: IconChevronRight,
    ChevronUp: IconChevronUp,
    ChevronUpLarge: IconChevronUpLarge,
};
//# sourceMappingURL=index.js.map